import React, { useState, useEffect } from 'react';
import '../../styles/Headers.css';
import logo from '../../assets/images/FBS_logo.png';
import 'boxicons/css/boxicons.min.css';
import { Link } from 'react-router-dom';
import announcement from '../../assets/images/notification.gif'
const Headers = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [openDropdowns, setOpenDropdowns] = useState({
        whyFBS: false,
        courses: false,
        admissions: false,
        placements: false
    });

    useEffect(() => {
        if (isMobileMenuOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
    }, [isMobileMenuOpen]);

    const handleLinkClick = () => {
        setIsMobileMenuOpen(false);
    };

    const toggleDropdown = (dropdown) => {
        setOpenDropdowns(prev => ({
            ...prev,
            [dropdown]: !prev[dropdown]
        }));
    };

    const MenuSection = ({ title, to, dropdownKey, children }) => {
        return (
            <div className="mobile-menu-section transform transition-all duration-300 hover:scale-[1.02] active:scale-[0.98]">
                <div 
                    className="flex justify-between items-center px-4 py-3 bg-white/10 backdrop-blur-sm rounded-xl shadow-sm hover:bg-white/20 transition-all duration-300"
                    onClick={() => toggleDropdown(dropdownKey)}
                >
                    <Link to={to} className="flex-grow text-gray-800 font-semibold text-lg">
                        {title}
                    </Link>
                    <i 
                        className={`fas fa-chevron-${openDropdowns[dropdownKey] ? 'up' : 'down'} text-gray-600 transition-transform`}
                    ></i>
                </div>
                {openDropdowns[dropdownKey] && (
                    <div className="pl-6 py-2 space-y-2 bg-white/5 rounded-b-xl">
                        {children}
                    </div>
                )}
            </div>
        );
    };
    
    const SubLink = ({ to, children }) => (
        <Link 
            to={to} 
            className="block px-4 py-2 text-gray-700 hover:bg-blue-50 rounded-md transition-colors duration-200"
            onClick={handleLinkClick}
        >
            {children}
        </Link>
    );
    
    return (
        <>
              <div className="topbar flex flex-col sm:flex-row justify-between items-center p-1 pr-6 pl-4">
                <div className="social-icons hidden sm:flex">
                    <a href="https://www.instagram.com/finxl_business_school/" target="_blank" rel="noopener noreferrer">
                        <i className='bx bxl-instagram' style={{ color: '#ff07cf' }}></i>
                    </a>
                    <a href="https://www.linkedin.com/company/fbs-finxl-business-school/" target="_blank" rel="noopener noreferrer">
                        <i className='bx bxl-linkedin' style={{ color: '#0000a8' }}></i>
                    </a>
                    <a href="https://www.facebook.com/profile.php?id=61561972892184" target="_blank" rel="noopener noreferrer">
                        <i className='bx bxl-facebook' style={{ color: '#3b5998' }}></i>
                    </a>
                    <a href="https://api.whatsapp.com/send?phone=918109240909" target="_blank" rel="noopener noreferrer">
                        <i className='bx bxl-whatsapp' style={{ color: '#00d100' }}></i>
                    </a>
                </div>

                <Link to='/announcements'>
                    <div className="info flex items-center">
                    <img src={announcement} alt="Notification" className="notification" style={{ width: "30px", height: "auto" }}  />
                        <span className="announcement">Announcement</span>
                    </div>
                </Link>

                <div className="contact-info flex items-center">
                    <i className='bx bxs-phone'></i>
                    <a href="tel:9158882688" className='relative right-[1rem]'>
                        915-888-2688
                    </a>
                    <i className='bx bxs-envelope'></i>
                    <a href="mailto:admission@fbsedu.in" className="relative right-[0.8rem]">admission@fbsedu.in</a>
                </div>
            </div> 

            <header className='headers-headers sticky top-0 left-0 right-0 z-50 bg-white shadow-md'>
                <div className="headers-container relative">
                    <div className="logo-container">
                        <Link to=''><img src={logo} alt="FINXL Business School" className="logo" /></Link>
                    </div>

                    <div className="nav-btn hidden lg:block">
                        <div className="nav-links">
                            <ul>
                                <li className="nav-link" style={{ "--i": ".6s" }}>
                                    <Link to='/'>Home</Link>
                                </li>
                                <li className="nav-link" style={{ "--i": ".85s" }}>
                                    <Link to='/about'>Why FBS<i className="fas fa-caret-down"></i></Link>
                                    <div className="dropdown">
                                        <ul>
                                            <li className="dropdown-link">
                                                <Link to='/about'>Overview</Link>
                                            </li>
                                            <li className="dropdown-link">
                                                <Link to='/about/mission'>Vision & Mission</Link>
                                            </li>
                                            <li className="dropdown-link">
                                                <Link to="/approvals">Recognition & Approvals</Link>
                                            </li>
                                            <li className="dropdown-link">
                                                <Link to='/about/campus'>Campus Life</Link>
                                            </li>
                                            <div className="arrow"></div>
                                        </ul>
                                    </div>
                                </li>
                                <li className="nav-link" style={{ "--i": "1.1s" }}>
                                    <Link to='/courses'>Courses<i className="fas fa-caret-down"></i></Link>
                                    <div className="dropdown">
                                        <ul>
                                            <li className="dropdown-link">
                                                <Link to='/courses'>View Courses</Link>
                                            </li>
                                            <li className="dropdown-link">
                                                <Link to='/certifications'>View Certification</Link>
                                            </li>
                                            <div className="arrow"></div>
                                        </ul>
                                    </div>
                                </li>
                                <li className="nav-link" style={{ "--i": "1.35s" }}>
                                    <Link to='/eligibility'>Admissions<i className="fas fa-caret-down"></i></Link>
                                    <div className="dropdown">
                                        <ul>
                                            <li className="dropdown-link">
                                                <Link to='/eligibility'>Overview & Eligibility</Link>
                                            </li>
                                            <li className="dropdown-link">
                                                <Link to='/scholarship'>Scholarships</Link>
                                            </li>
                                            <li className="dropdown-link">
                                                <Link to='/fees'>Fee Structure</Link>
                                            </li>
                                            <li className="dropdown-link">
                                                <Link to='/terms'>Terms & Conditions</Link>
                                            </li>
                                            <div className="arrow"></div>
                                        </ul>
                                    </div>
                                </li>
                                <li className="nav-link" style={{ "--i": "1.35s" }}>
                                    <Link to='/careers'>Careers</Link>
                                </li>
                                <li className="nav-link" style={{ "--i": "1.35s" }}>
                                    <Link to='/placed-student'>Placements<i className="fas fa-caret-down"></i></Link>
                                    <div className="dropdown">
                                        <ul>
                                            <li className="dropdown-link">
                                                <Link to='/placed-student'>Placed Students</Link>
                                            </li>
                                            <li className="dropdown-link">
                                                <Link to='/recruiters'>Our Recruiters</Link>
                                            </li>
                                            <li className="dropdown-link">
                                                <Link to='/placment-team'>Placement Team</Link>
                                            </li>
                                            <li className="dropdown-link">
                                                <Link to='/placment-policy'>Placement Policy</Link>
                                            </li>
                                            <div className="arrow"></div>
                                        </ul>
                                    </div>
                                </li>
                                <li className="nav-link" style={{ "--i": "1.35s" }}>
                                    <Link to='/contact'>Contact Us</Link>
                                </li>
                                <li className="nav-link" style={{ "--i": "1.35s" }}>
                                    <Link to='/register'>Register</Link>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div className="absolute right-4 z-[60] lg:hidden"> {/* Changed positioning here */}
                        <div 
                            className="hamburger-container bg-white p-2 rounded-lg shadow-md hover:shadow-lg transition-shadow"  
                            style={{
                                display: 'flex', 
                                flexDirection: 'column', 
                                width: '40px', 
                                height: '40px',
                                justifyContent: 'center',
                                cursor: 'pointer'
                            }}
                            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                        >
                            <div style={{
                                width: '100%', 
                                height: '3px', 
                                backgroundColor: 'navy', 
                                margin: '2px 0',
                                transition: 'all 0.3s ease',
                                transform: isMobileMenuOpen ? 'rotate(45deg) translate(5px, 5px)' : 'none'
                            }}></div>
                            <div style={{
                                width: '100%', 
                                height: '3px', 
                                backgroundColor: 'navy', 
                                margin: '2px 0',
                                opacity: isMobileMenuOpen ? 0 : 1,
                                transition: 'opacity 0.3s ease'
                            }}></div>
                            <div style={{
                                width: '100%', 
                                height: '3px', 
                                backgroundColor: 'navy', 
                                margin: '2px 0',
                                transition: 'all 0.3s ease',
                                transform: isMobileMenuOpen ? 'rotate(-45deg) translate(5px, -5px)' : 'none'
                            }}></div>
                        </div>
                    </div>
                </div>
                <div 
                className={`mobile-menu lg:hidden fixed inset-0 z-50 bg-gradient-to-br from-blue-50 to-blue-100 transition-all duration-500 ${
                    isMobileMenuOpen 
                        ? 'opacity-100 visible' 
                        : 'opacity-0 invisible pointer-events-none'
                }`}
                style={{ top: '0', height: '100vh' }}
            >
                {/* Logo Section */}
                <div className="logo-section p-6 flex justify-center items-center">
                    <img 
                        src={logo} 
                        alt="FINXL Business School" 
                        className="w-40 h-auto object-contain transform transition-transform hover:scale-105"
                    />
                </div>

                {/* Menu Content */}
                <div className="px-10 pb-6 space-y-4 overflow-y-auto h-[calc(100vh-150px)]">
                    <Link 
                        to="/" 
                        className="block px-4 py-3 text-gray-800 font-semibold text-lg bg-white/10 backdrop-blur-sm rounded-xl hover:bg-white/20 transition-all"
                        onClick={handleLinkClick}
                    >
                        Home
                    </Link>

                    <MenuSection title="Why FBS" to="/about" dropdownKey="whyFBS" className="relative right:8rem">
                        <SubLink to="/about">Overview</SubLink>
                        <SubLink to="/about/mission">Vision & Mission</SubLink>
                        <SubLink to="/approvals">Recognition & Approvals</SubLink>
                        <SubLink to="/about/campus">Campus Life</SubLink>
                    </MenuSection>

                    <MenuSection title="Courses" to="/courses" dropdownKey="courses">
                        <SubLink to="/courses">View Courses</SubLink>
                        <SubLink to="/certifications">View Certification</SubLink>
                    </MenuSection>

                                <MenuSection title="Admissions" to="/eligibility" dropdownKey="admissions">
                                    <SubLink to="/eligibility">Overview & Eligibility</SubLink>
                                    <SubLink to="/scholarship">Scholarships</SubLink>
                                    <SubLink to="/fees">Fee Structure</SubLink>
                                    <SubLink to="/terms">Terms and Conditions</SubLink>
                                </MenuSection>

                    <Link 
                        to="/careers" 
                        className="block px-4 py-3 text-gray-800 font-semibold text-lg bg-white/10 backdrop-blur-sm rounded-xl hover:bg-white/20 transition-all"
                        onClick={handleLinkClick}
                    >
                        Careers
                    </Link>

                    <MenuSection title="Placements" to="/placed-student" dropdownKey="placements">
                        <SubLink to="/placed-student">Placed Students</SubLink>
                        <SubLink to="/recruiters">Our Recruiters</SubLink>
                        <SubLink to="/placment-team">Placement Team</SubLink>
                        <SubLink to="/placment-policy">Placement Policy</SubLink>
                    </MenuSection>

                    <Link 
                        to="/contact" 
                        className="block px-4 py-3 text-gray-800 font-semibold text-lg bg-white/10 backdrop-blur-sm rounded-xl hover:bg-white/20 transition-all"
                        onClick={handleLinkClick}
                    >
                        Contact Us
                    </Link>

                    <Link 
                        to="/register" 
                        className="block px-4 py-3 text-white font-semibold text-lg bg-blue-500 rounded-xl hover:bg-blue-600 transition-all shadow-md"
                        onClick={handleLinkClick}
                    >
                        Register
                    </Link>
                </div>
            </div>

            </header>

            <main className="transition-all duration-300">
                {/* Your content here */}
            </main>
        </>
    );
};

export default Headers;